// frontend/src/landing/sections/CaseStudySchoolSection.tsx
import Brand from "../components/Brand";
import KPI from "../components/KPI";
import Section from "../components/Section";
import { useInViewOnce } from "../components/useInViewOnce";

export default function CaseStudySchoolSection() {
  const { ref, inView } = useInViewOnce<HTMLDivElement>({
    rootMargin: "0px 0px -20% 0px",
    threshold: 0.2,
  });

  return (
    <Section id="praxis" eyebrow="Fallstudie" title="Schule" badge="Echtbetrieb">
      <p className="zg-text">
        An der Grundschule Kestnerstraße ändert sich der Stundenplan im Schuljahr mehrfach.        
      </p>
      <p className="zg-text">
        Früher war der Plan erst nach mehreren Tagen und vielen Kompromissen akzeptabel, 
        aber selten für alle zufriedenstellend.
      </p>
      <p className="zg-text">
        Mit <Brand /> wurden alle Regeln der Schule explizit festgehalten und priorisiert.
        Nach wenigen Minuten Rechenzeit lag ein tragfähiger Plan vor.
      </p>
      
      <div ref={ref}>
        <div className="zg-cards">
          <KPI
            label="Bisheriger Prozess"
            value={59}
            suffix="%"
            decimals={0}
            animate
            active={inView}
            note="Erfüllungsgrad nach zwei Tagen Arbeit mit herkömmlicher Software"
          />
          <KPI
            label={<><Brand /> interaktiv</>}
            value={94}
            suffix="%"
            decimals={0}
            animate
            active={inView}
            note="Erfüllungsgrad während der Beschreibung der Regeln"
          />
          <KPI
            label={<><Brand /> Echtbetrieb</>}
            value={99}
            suffix="%"
            decimals={0}
            animate
            active={inView}
            note="Erfüllungsgrad nach zehn Minuten Rechenzeit"
          />
        </div>
      </div>

      <blockquote className="zg-quote">
        <p className="zg-quote-text">
          Dabei war sehr entscheidend, dass der Perspektivwechsel der Lehrkräfte beobachtet werden konnte: 
          Diskussionen verlagerten sich von der Bewertung einzelner Pläne hin zur gemeinsamen Priorisierung und Ressourcenverteilung. 
          Szenarien konnten unmittelbar berechnet, verglichen und auf sachlicher Ebene diskutiert werden. 
          Dadurch wurde insgesamt eine höhere Transparenz, geringere Konfliktbelastung und ein deutlich reduzierter Zeitaufwand erzielt.
        </p>
        <footer className="zg-quote-author">
          Uschi Albrecht, Schulleiterin
        </footer>
      </blockquote>
      
      <p className="zg-footnote">
        <Brand /> verbessert nicht nur Planqualität, sondern verändert den Planungsprozess selbst.
      </p>
      
    </Section>
  );
}